import React from "react";
import "./About.css";
import Textbox from "./Textbox"

const HowTo = () => {

  return (
    <>
    <div className="home">
      <div className="home__container">
            <Textbox heading="Betalning via Leksaksbilar.se" 
            text="Alla betalningar sker säkert via Leksaksbilar.se med deras etablerade betalningssystem:

• Klarna - Betala senare, dela på faktura eller direkt
• Kortbetalning - Visa, Mastercard, American Express
• Faktura - 14 dagars betalning för företag
• Swish - Snabb och säker betalning
• Banköverföring - Direkt från din bank

Alla betalningar är krypterade och säkra enligt PCI DSS-standarder." />

            <Textbox heading="Leveransinformation" 
                        text="Leksaksbilar.se hanterar all leverans och logistik:

• Leveranstid: 1-3 arbetsdagar (inom Sverige)
• Fraktkostnad: Gratis frakt över 299 kr
• Leverantör: PostNord, DHL eller Bring
• Spårning: Du får spårningsnummer via email
• Leverans till: Hemadress, ombud eller postombud
• Internationell leverans: Tillgänglig till Norden

Alla paket är försäkrade under transport." />

            <Textbox heading="Ångerrätt/Returer" 
                        text="Du har 14 dagars ångerrätt enligt Leksaksbilar.se returpolicy:

• Ångerrätt: 14 dagar från mottagandet
• Returkostnad: Gratis retur inom Sverige
• Skicka tillbaka: Använd returetikett från Leksaksbilar.se
• Återbetalning: Inom 5-7 arbetsdagar efter mottagande
• Produktkondition: Måste vara i originalförpackning
• Kontakt: Via Leksaksbilar.se kundservice

Vid retur får du full återbetalning inklusive fraktkostnad." />

            <Textbox heading="Köpvillkor" 
                        text="Genom att handla via Isaks Bilar godkänner du:

• Ålder: Du måste vara minst 18 år eller ha vårdnadshavarens samtycke
• Leverans: Endast till Sverige och Norden
• Produkter: Alla produkter följer EU:s säkerhetsstandarder
• Priser: Inkluderar moms, exkluderar frakt (om inte annat anges)
• Lagersaldo: Produkter kan vara slut i lager
• Leverantör: Leksaksbilar.se ansvarar för alla köp och leveranser
• Support: Kontakta Leksaksbilar.se för produktrelaterade frågor

Vi är en affiliate-partner och förmedlar endast till Leksaksbilar.se." />

      </div>
    </div>
</>
  );
};

export default HowTo;
